import { FilterFieldType, IFilter } from './types'

export const NOTES_LIST_PER_PAGE = 20

export const NOTES_LIST_SORT_OPTIONS = [
  {
    value: 'created_at DESC',
    label: 'Created (Newest)',
  },
  {
    value: 'created_at ASC',
    label: 'Created (Oldest)',
  },
  {
    value: 'resolved DESC',
    label: 'Resolved (Top)',
  },
  {
    value: 'resolved ASC',
    label: 'Resolved (Bottom)',
  },
  {
    value: 'updated_at DESC',
    label: 'Updated (Newest)',
  },
  {
    value: 'updated_at ASC',
    label: 'Updated (Oldest)',
  },
]

export const NOTES_LIST_FILTERS_CONFIG = [
  {
    field: 'noteText',
    dbField: 'note_text',
    type: FilterFieldType.Text,
    isSortable: true,
    placeholder: 'Note',
    title: 'Note',
  },
  {
    field: 'resolved',
    dbField: 'resolved',
    type: FilterFieldType.Text,
    isSortable: true,
    title: 'Resolved',
  },
  {
    field: 'createdAt',
    dbField: 'created_at',
    type: FilterFieldType.Date,
    isSortable: true,
    title: 'Created At',
  },
  {
    field: 'updatedAt',
    dbField: 'updated_at',
    type: FilterFieldType.Date,
    isSortable: true,
    title: 'Updated At',
  },
  {
    field: 'id',
    type: FilterFieldType.List,
    excludeColumn: true,
  },
  {
    field: 'dueDiligenceFilters',
    type: FilterFieldType.List,
    title: 'Status',
    isMultiple: true,
    excludeColumn: true,
  },
  {
    field: 'tags',
    type: FilterFieldType.List,
    title: 'Tag',
    isMultiple: true,
    excludeColumn: true,
  },
  {
    field: 'pages',
    type: FilterFieldType.List,
    title: 'Page',
    isMultiple: true,
    excludeColumn: true,
  },
] as const satisfies IFilter[]

export const DEFAULT_NOTES_LIST_FILTERS_CONFIG = [
  {
    field: 'noteText',
    dbField: 'note_text',
    type: FilterFieldType.Text,
    title: 'Note',
  },
  {
    field: 'tag',
    alias: 'tags',
    type: FilterFieldType.List,
    title: 'Tag',
    isMultiple: true,
  },
] as const satisfies IFilter[]
